export class StudentCurriculumModel {
  constructor(
    public studentEid: string,
    public contextInternalCourseCode: string,
    public courses: CourseModel[]
  ) { };
}

export class CourseModel {
  constructor(
    public defaultCreditsUnit: string,
    public defaultCredits: number,
    public activationMax : string,
    public activationRemaining : string,
    public internalCode : string,
    public name: string,
    public externalCode : string,
    public label : string,
    public programmeLevel : string,
    public businessUnitLevel : string,
    public serviceContract: ServiceContractModel,
    public modules: ModuleModel[],
    public educationDuration: number,
    public educationDurationUnit: EducationDurationUnits,
    public courseStatus: CourseStatus,
    public infoText: string
  ) { };
}

export class ServiceContractModel {
  constructor(
    public startDate: string,
    public endDate: string,
    public renewalsRemaining: number,
    public renewalsMax: number,
    public contractId: string,
    public contractStatus: ContractStatus,
    public contractType: ContractType,
    public courseVariant?: CourseVariant
  ) { };
}

export class ModuleModel {
  public internalCode: string;
  public name: string;
  public externalCode: string;
  public phase: string;
  public defaultCredits: number;
  public defaultCreditsUnit: string;
  public activationStartDate: string;
  public activationEndDate: string;
  public availableFromDate: string;
  public availableToDate: string;
  public result: string;
  public modulePrerequisites: string[];
  public status: ModuleStatus;
  public reason: ModuleReason;
  public statusText: string;
  public activationInProgress: boolean;

  public constructor(init?: Partial<ModuleModel>) {
    Object.assign(this, init);
  }
}

export enum ContractStatus {
  NABEHANDELING = 1,
  INGESCHREVEN = 2,
  SCHORSING = 3,
  WANBETALING = 4,
  OGNOVERIG = 5,
  AFSTUDEREN = 6,
  OVERLIJDEN = 7,
  KLANTOVERIG = 8,
  ANNULERINGOGN = 9,
  ANNULERINGKLANT = 10,
  HERROEPEN = 11,
  GEDIPLOMEERD = 12,
  VRIJSTELLINGZONDERINSCHRIJVING = 13,
  INGESCHREVENNIETTOELAATBAAR = 14,
}

export enum EducationDurationUnits {
  YEARS = 1,
  MONTHS = 2,
  WEEKS = 3,
  DAYS = 4
}

export enum ContractType {
  AFSTAND = 1,
  KLASSIKAAL = 2,
  INCOMPANY = 3
}

export enum ModuleStatus {
  AVAILABLE = 1,
  ACTIVATED_FROM_START = 2,
  ACTIVATED = 3,
  ALWAYS_ACTIVE = 4,
  FINISHED = 5,
  EXEMPTION = 6,
  UNAVAILABLE = 7
}

export enum ModuleReason {
  UNKNOWN = 1,
  NOT_ACTIVATABLE = 2,
  NO_REMAINING_ACTIVATIONS = 3,
  MISSING_PREREQUISITES = 4,
  MEETING_OFFER = 5,
  NO_SERVICE_CONTRACT = 6,
  FUTURE_ACTIVATIONDATE = 7,
  MISSING_APPROVAL_PARENT = 8,
  STUDY_FUTURE_STARTDATE = 9,
  PREVIOUS_VERSION_ACTIVATED = 10
}

export enum CourseStatus {
  NOT_STARTED_NOT_APPROVED = 1,
  NOT_ADMITTED_AND_NOT_STARTED = 2,
  NOT_ADMITTED_AND_STARTED = 3,
  NOT_ADMITTED_AND_STARTED_AND_LOI_ACTIVATED = 4,
  NOT_ADMITTED_AND_STARTED_AND_STUDENT_ACTIVATED = 5,
  STARTED_AND_LOI_ACTIVATED = 6,
  NOT_STARTED = 7,
  LOI_ACTIVATED = 8,
  LOI_ACTIVATED_AND_STUDENT_ACTIVATED = 9,
  SERVICE_CONTRACT_EXPIRING_AND_RENEWALS_REMAINING = 10,
  SERVICE_CONTRACT_EXPIRING_AND_NO_RENEWALS_REMAINING = 11,
  SERVICE_CONTRACT_EXPIRED_AND_RENEWALS_REMAINING = 12,
  SERVICE_CONTRACT_EXPIRED_AND_NO_RENEWALS_REMAINING = 13,
  STUDENT_PASSED_AWAY = 14,
  NO_ACCESS = 15,
  FOLLOW_UP_AND_STARTED_AND_LOI_ACTIVATED = 16,
  FOLLOW_UP_AND_STARTED_AND_STUDENT_ACTIVATED = 17
}

export enum CourseVariant
{
    MBO = 1,
    MBOBO = 2,
    MBOC = 3,
    MBODP = 4,
    MBOIP = 5,
    MBOKD = 6,
    HBOAD = 7,
    HBOBA = 8,
    HBOC = 9,
    HBOKP = 10,
    HBOMA = 11,
    HBOMC = 12,
    HBOPB = 13,
    CUR = 14,
    CURH = 15,
    CURM = 16,
    CURZ = 17,
    HVT = 18,
    KIDZZ = 19,
    VO = 20,
    CURME = 21,
    HBOMI = 22,
}

export class PhaseModel {
  public modules: ModuleModel[];
  constructor(
    public name: string,
    public order: number,
  ) {
      this.modules = [];
  };
}
